@if (voucher$ | async; as voucher) {
  <!-- Zweigeteilt: links 2/3 der Gutschein selbst, rechts 1/3 was noch drauf
       ist und der Weg in den Verlauf. -->
  <div class="voucher-card">
    <div class="voucher-card__main">
      <!-- Jolioo liefert den Titel der Gutschein-Aktion; ohne einen bliebe die
           Karte sonst kopflos. -->
      <p class="card-title">
        {{ voucher.title || ("PAGES.VOUCHER.TITLE_FALLBACK" | translate) }}
      </p>
      <p class="caption voucher-card__code">{{ voucher.code }}</p>
    </div>

    <div class="voucher-card__aside">
      <p class="voucher-card__balance voucher-card__balance--stacked">
        <span class="paragraph-highlight"
          >€ {{ balance$ | async | number: "1.2-2" }}</span
        >
        <!-- ⚠ Immer dieselbe Beschriftung: der Wert ist in beiden Faellen das,
             was jetzt auf dem Gutschein ist — gerechnet wird erst im naechsten
             Schritt. -->
        <span class="body-small">{{
          "PAGES.VOUCHER.BALANCE" | translate
        }}</span>
      </p>

    </div>
  </div>

  <!-- Unter der Karte statt in der rechten Spalte: dort blieben fuer den Text
       nur ~70px und "Einlösehistorie ansehen" brach zwangslaeufig um. -->
  @if ((history$ | async)?.length) {
    <app-text-button
      class="voucher-history-link"
      icon="icons/24/history.svg"
      [label]="'PAGES.VOUCHER.HISTORY.OPEN' | translate"
      (action)="openHistory()"
    ></app-text-button>
  }

  <div class="spacer spacer-3"></div>

  @if (voucher.state === VOUCHER_STATE.VALID) {
    <!-- Als Formular, damit Enter im Betragsfeld direkt reserviert. -->
    <form (ngSubmit)="reserve()">
      <!-- Eigene Variante: zwei bis fuenf Ziffern brauchen keine Bildschirmbreite. -->
      <app-input-text
        class="voucher-amount-field"
        [label]="'PAGES.VOUCHER.AMOUNT.LABEL' | translate"
        [placeholder]="'PAGES.VOUCHER.AMOUNT.PLACEHOLDER' | translate"
        [errorText]="amountError"
        [required]="true"
        [invalid]="!!amountError"
        type="number"
        [value]="amountInput"
        [maxDecimals]="2"
        [min]="0"
        [max]="balance$ | async"
        [autoFocus]="true"
        (currentValue)="onAmountChange($event)"
      ></app-input-text>
      <div class="spacer spacer-half"></div>
      <div class="voucher-amount-hint">
        <p class="label-form-helper">
          {{
            "PAGES.VOUCHER.AMOUNT.MAX"
              | translate: { value: (balance$ | async | number: "1.2-2") }
          }}
        </p>
        <app-text-button
          class="voucher-amount-full"
          [label]="'PAGES.VOUCHER.AMOUNT.FULL' | translate"
          (action)="setFullAmount()"
        ></app-text-button>
      </div>

      <div class="spacer spacer-3"></div>

      @if ((reserveStatus$ | async) === STATES.LOADING) {
        <app-loading></app-loading>
      } @else {
        <app-button
          [label]="'PAGES.VOUCHER.RESERVE' | translate"
          [buttonType]="ButtonType.Blue"
          [disabled]="!canReserve"
          [fullWidth]="true"
          (action)="reserve()"
        ></app-button>
      }
    </form>

    @if ((reserveStatus$ | async) === STATES.ERROR) {
      <div class="spacer spacer-2"></div>
      <app-message-box
        [message]="reserveError"
        [messageType]="MessageType.Error"
      ></app-message-box>
      <div class="spacer spacer-2"></div>
      <!-- Wiederholung mit demselben Idempotenz-Schlüssel. -->
      <app-button
        [label]="'PAGES.VOUCHER.RETRY' | translate"
        [buttonType]="ButtonType.Blue"
        [fullWidth]="true"
        (action)="retryReserve()"
      ></app-button>
    }
  } @else {
    <app-message-box
      [message]="'PAGES.VOUCHER.NOT_REDEEMABLE' | translate"
      [messageType]="MessageType.Error"
    ></app-message-box>
  }

  <div class="spacer spacer-2"></div>
  <app-button
    [label]="'PAGES.VOUCHER.OTHER_VOUCHER' | translate"
    [buttonType]="ButtonType.Secondary"
    [fullWidth]="true"
    (action)="startOver()"
  ></app-button>
  <div class="spacer spacer-4"></div>
}

<app-info-modal [(open)]="showHistory">
  @if (showHistory) {
    <div class="voucher-history-sheet">
      <div class="voucher-history-sheet__header">
        <p class="header-title">
          {{ "PAGES.VOUCHER.HISTORY.TITLE" | translate }}
        </p>
        <app-icon-button
          [src]="'icons/24/close.svg'"
          [attr.aria-label]="'PAGES.VOUCHER.HISTORY.CLOSE' | translate"
          (action)="closeHistory()"
        ></app-icon-button>
      </div>
      <div class="voucher-history-sheet__content">
        <app-voucher-history></app-voucher-history>
      </div>
    </div>
  }
</app-info-modal>

<app-confirm-modal
  [(open)]="showStartOverConfirm"
  [title]="'PAGES.VOUCHER.LEAVE.TITLE' | translate"
  [text]="'PAGES.VOUCHER.LEAVE.TEXT' | translate"
  [confirmLabel]="'PAGES.VOUCHER.LEAVE.CONFIRM' | translate"
  [dismissLabel]="'PAGES.VOUCHER.LEAVE.DISMISS' | translate"
  (confirmed)="confirmStartOver()"
></app-confirm-modal>
